import {Controller} from "@hotwired/stimulus"
import { easepick } from "@easepick/bundle"
import { RangePlugin } from '@easepick/range-plugin'
import { AmpPlugin } from '@easepick/amp-plugin'

export default class extends Controller {
  static targets = ["since", "until"];
  static values = {
    auto: { type: Boolean, default: false },
    reset: { type: Boolean, default: true },
    read: { type: Boolean, default: true }
  };
  connect() {
    const that = this;
    let since, until;
    this.form = that.sinceTarget.form;
    if (that.sinceTarget.value) {
      since =  Date.parse(that.sinceTarget.value)
    }
    if (that.untilTarget.value) {
      until =  Date.parse(that.untilTarget.value)
    }
    this.picker = new easepick.create({
      element: that.sinceTarget,
      css: [
        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
      ],
      zIndex: 100,
      lang: 'ru-RU',
      readonly: this.readValue,
      format: "DD.MM.YYYY",
      plugins: [
        RangePlugin,
        AmpPlugin
      ],
      RangePlugin: {
        startDate: since,
        endDate: until,
        elementEnd: that.untilTarget,
        reposition: false,
        locale: {
          one: "день",
          two: "дня",
          few: "дня",
          many: "дней"
        }
      },
      AmpPlugin: {
        resetButton: that.resetValue
      }
    });

    this.untilTarget.addEventListener('focus', () => {
      this.sinceTarget.click();
    });

    if (that.autoValue) {
      this.picker.on('select', (e) => {
        that.sinceTarget.form.requestSubmit();
        this.showLoader();
      })

      this.picker.on('clear', (e) => {
        that.sinceTarget.form.requestSubmit();
      })
    }
  }

  applyPreset(event) {
    const preset = event.target.value;
    if (!preset || !this.picker) return;

    const today = new Date();
    let start, end;

    switch (preset) {
      case "last_7_days":
        end = new Date(today);
        start = new Date(today);
        start.setDate(today.getDate() - 6);
        break;

      case "this_week": {
        const currentDay = today.getDay();
        const distanceToMonday = currentDay === 0 ? -6 : 1 - currentDay;
        start = new Date(today);
        start.setDate(today.getDate() + distanceToMonday);
        end = new Date(today);
        break;
      }

      case "last_week": {
        const day = today.getDay();
        const distMonday = day === 0 ? -6 : 1 - day;
        start = new Date(today);
        start.setDate(today.getDate() + distMonday - 7);
        end = new Date(start);
        end.setDate(start.getDate() + 6);
        break;
      }

      case "this_month":
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date(today);
        break;

      case "last_month":
        start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        end = new Date(today.getFullYear(), today.getMonth(), 0);
        break;

      case "this_year":
        start = new Date(today.getFullYear(), 0, 1);
        end = new Date(today);
        break;

      default:
        start = new Date(today);
        end = new Date(today);
        start.setDate(today.getDate() - 6);
        break;
    }


    if (start && end) {
      this.picker.setDateRange(start, end);
      if (this.autoValue) {
        this.form.requestSubmit();
        this.showLoader();
      }
    }
  }

  showLoader() {
    this.element.innerHTML = `<div class="flex items-center justify-center">
      <div class="h-6 w-6 rounded-full border-4 border-t-4 border-gray-50 border-t-orange-700 animate-spin"></div>
    </div>`;
  }
}